/*
  Journey map — behaviour for sections/journey-map.liquid.

  The artwork is ~190-390 KB per variant, which is well over the 256 KB Liquid
  template limit and the 15 KB inline_asset_content limit, so the two drawings
  live in assets/journey-map.svg (wide) and assets/journey-map-mobile.svg
  (stacked) and are fetched and injected inline here. Inline (rather than <img>)
  is what keeps them themeable by the section's CSS and clickable.

  Which one loads depends on the viewport, and it is swapped if the breakpoint is
  crossed. Each <g class="step" id="..."> then gets its URL from a data-link-*
  attribute on the section wrapper, so the merchant's settings stay the single
  source of truth, and is given link semantics for mouse and keyboard.
*/
(function () {
  // SVG group id -> the section setting that supplies its URL. The two drawings
  // name their groups differently, so both sets live here; only one is present
  // in the DOM at a time.
  var STEPS = {
    // Wide artwork.
    Browse_Your_Options: 'browse',
    Get_In_The_Know: 'know',
    Order_Your_Free: 'samples',
    Visit_One_of_Our: 'visit',
    Inspect_and_Measure: 'measure',
    Choose_flooring: 'choose',
    Get_Quote: 'quote',
    Place_your_Order: 'order',
    Install: 'install',
    Aftercare: 'aftercare',
    // Stacked artwork.
    Get_In_the_know: 'know',
    Visit_One: 'visit',
    Inspect_Measure: 'measure',
    Choose_your_new: 'choose',
    Get_Your: 'quote',
    Place_Your_Order: 'order',
    install: 'install',
    Learn_How: 'aftercare',
  };

  function label(step) {
    return (step.dataset.name || step.id || '').replace(/[_-]+/g, ' ').trim();
  }

  // Steps are <g> elements, so they need explicit link semantics.
  function wireUp(root, container) {
    Object.keys(STEPS).forEach(function (id) {
      var step = root.querySelector('#' + id + '.step');
      if (!step) return;
      var url = container.getAttribute('data-link-' + STEPS[id]);
      if (!url) return;
      step.dataset.link = url;
      step.setAttribute('role', 'link');
      step.setAttribute('tabindex', '0');
      step.setAttribute('aria-label', label(step));
    });
  }

  // Which drawing suits the current viewport. Falls back to the wide one when no
  // stacked variant is set.
  function variantUrl(container) {
    var mobile = container.getAttribute('data-journey-map-mobile');
    var breakpoint = parseInt(container.getAttribute('data-journey-breakpoint'), 10);
    if (mobile && breakpoint && window.matchMedia('(max-width: ' + breakpoint + 'px)').matches) {
      return mobile;
    }
    return container.getAttribute('data-journey-map');
  }

  function load(container) {
    var url = variantUrl(container);
    if (!url || container.dataset.journeyLoaded === url) return;
    container.dataset.journeyLoaded = url;

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (markup) {
        var target = container.querySelector('[data-journey-canvas]');
        if (!target) return;
        // The viewport may have changed again while this was in flight.
        if (container.dataset.journeyLoaded !== url) return;
        target.innerHTML = markup;
        var svg = target.querySelector('svg');
        if (svg) svg.classList.add('journey-map');
        wireUp(target, container);
      })
      .catch(function (err) {
        console.error('Journey map could not be loaded', err);
        container.dataset.journeyLoaded = '';
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-journey-map]').forEach(load);
  }

  // Swap the drawing if the breakpoint is crossed; load() is a no-op when the
  // right one is already in place.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { init(); }, 200);
  });

  function go(step, newTab) {
    var url = step.dataset.link;
    if (!url) return;
    if (newTab) window.open(url, '_blank', 'noopener');
    else window.location.href = url;
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('.journey-map .step[data-link]');
    if (!step) return;
    e.preventDefault();
    go(step, e.metaKey || e.ctrlKey);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var step = e.target.closest && e.target.closest('.journey-map .step[data-link]');
    if (!step) return;
    e.preventDefault();
    go(step, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Theme editor: the section is re-rendered wholesale, so load its map again.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
